import { render } from "./OrderFilter.vue?vue&type=template&id=70cbf0ef"
import script from "./OrderFilter.vue?vue&type=script&lang=js"
export * from "./OrderFilter.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/navbarFilter/OrderFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70cbf0ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70cbf0ef', __exports__)) {
    console.log('reload')
    api.reload('70cbf0ef', __exports__)
  }
  
  module.hot.accept("./OrderFilter.vue?vue&type=template&id=70cbf0ef", () => {
    console.log('re-render')
    api.rerender('70cbf0ef', render)
  })

}


export default __exports__